export default class Question {
    constructor(json) {
        if (!json) {
            return;
        }

        this.need = json.need || 0;
        this.scaleName = json.scale_name || '';
    }
}
